






































































































import { Vue, Component } from "vue-property-decorator";
import { namespace } from "vuex-class";

import Loader from "@/modules/externals/components/Loader.vue";
import AllBusinessesTable from "@/modules/businesses/components/AllBusinessesTable.vue";
import ApprovedBusinessesTable from "@/modules/businesses/components/ApprovedBusinessesTable.vue";
import RejectedBusinessesTable from "@/modules/businesses/components/RejectedBusinessesTable.vue";
import { Business } from "@/modules/businesses/types/index";
import { FetchPayload } from "@/modules/businesses/types/index";
import PendingBusinessesTable from "./PendingBusinessesTable.vue";

const Businesses = namespace("business");

@Component({
  components: {
    loader: Loader,
    "all-businesses-table": AllBusinessesTable,
    "approved-businesses-table": ApprovedBusinessesTable,
    "rejected-businesses-table": RejectedBusinessesTable,
    "pending-businesses-table": PendingBusinessesTable,
  },
})
export default class BusinessesTable extends Vue {
  @Businesses.Action("fetchBusinesses") fetchBusinesses!: (
    payload?: FetchPayload
  ) => Promise<{}>;
  @Businesses.Action("viewAllBusinesses") viewAllBusinesses: () => void;
  @Businesses.Getter("getAllBusinesses") businesses: Business[];
  @Businesses.Getter("getAllApprovedBusinesses")
  allApprovedBusinesses: Business[];
  @Businesses.Getter("getAllRejectedBusinesses")
  allRejectedBusinesses: Business[];
  @Businesses.Getter("getAllPendingBusinesses")
  allPendingBusinesses: Business[];
  @Businesses.Getter("isViewing") isViewing: boolean;
  @Businesses.Getter("query") query: string;
  @Businesses.Action("viewAllApproved") viewAllApproved: () => void;
  @Businesses.Action("viewAllRejected") viewAllRejected: () => void;
  @Businesses.Action("viewAllPending") viewAllPending: () => void;
  @Businesses.Getter("getSortOrder") sortOrder: string;
  @Businesses.Getter("getSortBy") sortBy: string;
  @Businesses.Action("setSortOrder")
  setSortOrder!: (sortOrder: string) => void;
  @Businesses.Action("setSortBy")
  setSortBy!: (sortBy: string) => void;
  @Businesses.Action("setQuery") setQuery: (query: string) => void;

  hasBusinessesError = false;
  businessError = "";

  beforeMount() {
    this.fetch();
  }

  fetch() {
    //Fetch All
    this.fetchBusinesses({ status: "all" }).catch((err) => {
      this.hasBusinessesError = true;
      this.businessError = err.message;
    });
    //Fetch All Approved
    this.fetchBusinesses({ status: "approved" }).catch((err) => {
      this.hasBusinessesError = true;
      this.businessError = err.message;
    });
    //Fetch All Rejected
    this.fetchBusinesses({ status: "rejected" }).catch((err) => {
      this.hasBusinessesError = true;
      this.businessError = err.message;
    });
    //Fetch All Pending
    this.fetchBusinesses({ status: "pending" }).catch((err) => {
      this.hasBusinessesError = true;
      this.businessError = err.message;
    });
  }

  async sort(sortBy, sortOrder, status = "all") {
    this.setSortOrder(sortOrder);
    this.setSortBy(sortBy);
    await this.fetchBusinesses({
      status: status,
    }); 
    }

  async searchForBusinesses(e) {
    if (e.keyCode === 13) {
      this.setQuery(e.target.value);
      //Fetch All
      await this.fetch();
    }
  }

 fetchAllBusinesses() {
    this.viewAllBusinesses();
  }

 fetchApprovedBusinesses() {
    this.viewAllApproved();
  }

 fetchRejectedBusinesses() {
    this.viewAllRejected();
  }
  fetchPendingBusinesses() {
    this.viewAllPending();
  }
}
